export default __webpack_public_path__ + "static/media/movie4.488d087a.png";